/**
 * @file Controle da execução em jogo. 
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */

import React from 'react';
import Board from './Board';
import Level from './ControlLevel';
import Inicio from './Inicio';
import Infos from './Infos';
import Instrucao from './Instrucao';
import Vitoria from './Vitoria';
import Nav from './Nav';
//Componentes de Estilo
import 'rsuite/dist/styles/rsuite-default.css';
import { Button, Icon} from 'rsuite';
// Componentes Front-end
import '../style/style.css';
import '../style/diretrizes.css';
import '../style/componentes.css';

// import Data from '../conteudo/palavras08102019';

//Componentes de roteamento
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */

export default function App() {



  var LevelManager = new Level();
  // (preciso colocar as funções de roteamenteo)
  // colocar controle de estados da aplicação
  return (
      <Router
       basename="/app/caca-palavra/"
       >
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route exact path="/">
            <Tela_Inicial />
          </Route>
          <Route exact path="/compartilhar">
            <Compartilhar />
          </Route>
          <Route exact path="/creditos">
            <Creditos />
          </Route>
          <Route exact path="/instrucao1">
            <Tela_Inst1 />
          </Route>
          <Route exact path="/instrucao1">
            <Tela_Inst1 />
          </Route>
          <Route exact path="/instrucao2">
            <Tela_Inst2 />
          </Route>
          <Route exact path="/instrucao3">
            <Tela_Inst3 />
          </Route>
          <Route exact path="/instrucao4">
            <Tela_Inst4 />
          </Route>
          <Route exact path="/instrucao5">
            <Tela_Inst5 />
          </Route>
          <Route exact path="/modo">
            <Tela_Modo />
          </Route>
          <Route exact path="/jogo">
            <Jogo />
          </Route>
          <Route exact path="/vitorial">
            <Vitorial />
          </Route>
        </Switch>
      </Router >
  );
  function Tela_Inicial() {
    // Build final REMOVER
    // console.log(Data);
    // var Resp = [];
    // var Dica = [];
    // var Ajuda = [];

    // for (let index = 0; index < Data.length; index++) {
    //   let element = Data[index];
    //   if(!Resp.includes([element['Resposta'].length, element['Resposta']])){
    //     console.log(Resp.includes([element['Resposta'].length, element['Resposta']]));
    //     Resp.push([element['Resposta'].length, element['Resposta']]);
    //     console.log(Resp.includes([element['Resposta'].length, element['Resposta']]));
    //   }
    //   Dica.push([element['informacao'].length, element['informacao']]);
    //   Ajuda.push([element['Help'].length, element['Help']]);

    // }

    // console.log(Resp.sort());
    // console.log(Dica.sort());
    // console.log(Ajuda.sort());

    return (
      
      <div className='container center baselinelayout'>
        <Inicio />
      </div>
    );
  }

  function Compartilhar() {
    
    return (
      <div className='container center baselinelayout'>
        <Infos
          col1={
            <div className="col fullWidth center distributed4 fullHeight padding-top-bottom">
              <div className="col center ">
                <h5 className="Color1">COMPARTILHE O JOGO CAÇA PALAVRAS</h5>                                    
                <p className="Color3 magro">Convide amigos e familiares para jogar!</p>
              </div>
              <div className="row distributed4 padding-top">
                <div className="col">
                  <div  class="fb-share-button" 
                      data-href="http://eic.ifsc.usp.br/app/caca-palavra/" 
                      // data-href="https://illiamw.github.io/app/caca-palavra/" 
                      
                  >
                      <a  
                        target="_blank" 
                        // href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Filliamw.github.io%2Fapp%2Fcaca-palavra%2F&amp;src=sdkpreparse" 
                        href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Feic.ifsc.usp.br%2Fapp%2Fcaca-palavra%2F&amp;src=sdkpreparse" 
                        className="iconShare">
                        <Icon className='iconShare' icon='facebook-square' size='4x'/>
                        <p className="iconShare">Facebook</p>
                      </a>
                    </div>
                </div>
                <div className="col">
                  <a target="_blank" href="https://api.whatsapp.com/send?text=Jogue agora mesmo http://eic.ifsc.usp.br/app/caca-palavra/ ">
                  {/* <a target="_blank" href="https://api.whatsapp.com/send?text=Jogue agora mesmo https://illiamw.github.io/app/caca-palavra/ "> */}

                  <Icon className='iconShare' icon='whatsapp' size='4x'/><p className="iconShare">Whatsapp</p>
                  </a>
                </div>
                
              </div>
            </div>
          }

          col2={
            <div className="col fullWidth center distributed4 fullHeight bkColor3 border1 padding-top-bottom">
              <div className="col center ">
                <h5 className="Color1">SIGA O EIC NAS REDES SOCIAIS</h5>                              
                <p className="Color2 magro "><a className="Color2 magro iconShare" target="_blank" href="http://eic.ifsc.usp.br/">http://eic.ifsc.usp.br/</a></p>
              </div>
              <div className="row distributed4 Color2 padding-top">
                <div className="col">                  
                  <a target="_blank" href="https://www.instagram.com/eiciencia/?hl=pt-br">
                    <Icon className='Color2 iconShare' icon='instagram' size='4x'/><p className="Color2 iconShare">Instagram</p>
                  </a>
                </div>
                
                <div className="col">
                  <a target="_blank" href="https://www.facebook.com/EIC.USP">
                    <Icon className='Color2 iconShare' icon='facebook-square' size='4x'/><p className="Color2 iconShare">Facebook</p>
                  </a>
                </div>
                <div className="col">
                  <a target="_blank" href="https://www.youtube.com/channel/UCjg75EYzCSLYCcxcXOuv_-g">
                    <Icon className='Color2 iconShare' icon='youtube-play' size='4x'/><p className="Color2 iconShare">Youtube</p>
                  </a>
                </div>
                
              </div>

            </div>

          }

          volta={
            <Link to="/"><h6 className='iconShare'><Icon className='iconShare' icon='back-arrow' size='1x'/> VOLTAR</h6></Link>

          }

        />
      </div>

    );
  }


  function Creditos() {
    return (
      <div className='container center baselinelayout'>
        <Infos
          col1={
            <div className="col fullWidth text-creditos distributed3 fullHeight padding-creditos">
              <div className="sesson">
                <h5 className="Color1">COORDENAÇÃO E SUPERVISÃO GERAL</h5>                                    
                <p className="Color3 magro">Profa. Dra. Leila M. Beltramini</p>
                <p className="Color3 magro">Profa. Dra. Nelma R. Segnini Bossolan</p>
              </div>
              <div className="sesson">
                <h5 className="Color1">EDUCADORA</h5>                                    
                <p className="Color3 magro">Ma. Gislaine Costa dos Santos</p>
              </div>
              <div className="sesson">
                <h5 className="Color1">CONSULTOR DE TECNOLOGIA DA INFORMAÇÃO</h5>                                    
                <p className="Color3 magro">Me. Claudinei Caetano de Souza</p>
                <p className="Color3 magro">Dra. Simone Ferreira Souza</p>
              </div>
            </div>
          }

          col2={
            <div className="col fullWidth text-creditos distributed3 fullHeight">
              <div className="sesson">
                <h5 className="Color1">DESENVOLVIMENTO DO SOFTWARE</h5>                                    
                <p className="Color3 magro">Luísa Gabriela Tupan Anastácio (versão 1.0)</p>
                <p className="Color3 magro">Claudinei Caetano de Souza (versão 1.0)</p>
                <p className="Color3 magro">William Luis Alves Ferreira (versão 2.0)</p>

              </div>
              <div className="sesson">
                <h5 className="Color1">CONTEÚDO</h5>                                    
                <p className="Color3 magro">Ma. Marília Faustino da Silva</p>                                  
                <p className="Color3 magro">Ma. Gislaine Gomes da Costa</p>
                <p className="Color3 magro">Rudison Beltramini Trevilato</p>
              </div>
            </div>

          }

          volta={
            <Link to="/"><h6 className='iconShare'><Icon className='iconShare' icon='back-arrow' size='1x'/> VOLTAR</h6></Link>

          }

        />
      </div>

    );
  }

  function Vitorial() {
    return (
      <div className="main-side">
        <Nav />
        <div className='container center'>
        <Vitoria
          col1={
            <div className="col fullWidth justify center medHeight">
              <div className="center text-center">
                <div className='palavraCertaVitoria '>
                        <h3>PARABÉNS!</h3>
                </div>
                <h5 className="Color4 text-center margin-top">Você conluiu o nível X</h5>                                    
                <div className='row distributed center margin-bottom margin-top'>
                    <div className=' row visor bkColor2 destaque1'>
                        <div className='tag Color1'>Pontuação</div>
                        <div className='value bkColor3'>1000</div>
                    </div>

                    <div className='row visor bkColor2 destaque1'>
                        <div className='tag Color1'>Cronometro</div>
                        <div className='value bkColor3'>
                            03:00
                        </div>
                    </div>
                </div>
              </div>
              
            </div>
          }

          col2={
            <div className="col fullWidth justify center medHeight">
             <div className="text-center">
                <h5 className="Color4">Aprenda ainda mais enquanto se diverte!<br/> Desafie-se e jogue novamente</h5>                                    
                <Link to="/modo">
                  <Button className='sizeButton borColor1 Color4 button1 buttonIncial'><Icon icon='gamepad' size='2x' /> Jogar</Button>
                </Link>
              </div>
            </div>

          }

        />
      </div>
          </div>
    );
  }

  function Tela_Inst1() {
    return (
      <div className="main-side">
        <Nav />
        <div className='container center'>
          <Instrucao
            title={'Instruções'}
            content={<h3>Você deve encontrar, no menor tempo possível, as palavras posicionadas na horizontal, vertical ou na diagonal!</h3>}
            nav1={<Link to="/">
              <Button className='borColor1 Color4 button1 buttonR sizeButton'><Icon icon='caret-left' size='3x' /></Button>
            </Link>
            }
            nav2={
              <Link to="/instrucao2">
                <Button className='borColor1 Color4 button1 buttonR sizeButton'><Icon icon='caret-right' size='3x' /></Button>
              </Link>
            }
            button={
              <Link to="/modo"><h6 className="Color4">PULAR INSTRUÇÕES</h6></Link>
            }

          />
        </div>
      </div>

    );
  }


  function Tela_Inst2() {
    var texto = <h3></h3>
    if (window.screen.width < 768) {
      texto = <h3>Acesse os cartões numerados clicando sobre o ícone <Icon icon='info' size="2x" />, sempre que necessário, para identificar as palavras escondidas! </h3>
    } else {
      texto = <h3>Use os cartões numerados, sempre que necessário, para identificar as palavras escondidas!</h3>
    }
    return (
      <div className="main-side">
        <Nav />
        <div className='container center'>
          <Instrucao
            title={'Instruções'}
            content={texto}
            nav1={<Link to="/instrucao1">
              <Button className='borColor1 Color4 button1 buttonR sizeButton'><Icon icon='caret-left' size='3x' /></Button>
            </Link>
            }
            nav2={
              <Link to="/instrucao3">
                <Button className='borColor1 Color4 button1 buttonR sizeButton'><Icon icon='caret-right' size='3x' /></Button>
              </Link>
            }

            button={
              <Link to="/modo"><h6 className="Color4">PULAR INSTRUÇÕES</h6></Link>
            }

          />
        </div>
      </div>
    );
  }

  function Tela_Inst3() {
    var texto = <h3></h3>
    if (window.screen.width < 768) {
      
         texto = <h3>Quando precisar de uma ajudinha extra, clique sobre o ícone <Icon icon='lock' size="3x" /> para desbloquear uma dica (em troca de 50 pontos do placar).</h3>
    } else {
      texto = <h3>Quando precisar de uma ajudinha extra, clique sobre o ícone <Icon icon='lock' size="2x" /> para desbloquear uma dica (em troca de 50 pontos do placar).</h3>
    }
    return (
      <div className="main-side">
        <Nav />
        <div className='container center'>
          <Instrucao
            title={'Instruções'}
            content={texto}
            nav1={<Link to="/instrucao2">
              <Button className='borColor1 Color4 button1 buttonR sizeButton'><Icon icon='caret-left' size='3x' /></Button>
            </Link>
            }
            nav2={
              <Link to="/instrucao4">
                <Button className='borColor1 Color4 button1 buttonR sizeButton'><Icon icon='caret-right' size='3x' /></Button>
              </Link>
            }

            button={
              <Link to="/modo"><h6 className="Color4">PULAR INSTRUÇÕES</h6></Link>
            }

          />
        </div>
      </div>
    );
  }

  function Tela_Inst4() {
    var texto = <h2></h2>
    if (window.screen.width < 768) {
      
      texto = <span><h3>Modo de Jogo</h3><br/><h4>Fácil - 6 Palavras, com palavras de baixa complexidade<br/>Médio - 8 Palavras, com palavras de média complexidade<br/>Díficil - 10 palavras, com palavras de alta complexidade</h4></span>
    } else {
      texto = <span><h3>Modo de Jogo</h3><br/><h4>Fácil - 6 Palavras, com palavras de baixa complexidade<br/>Médio - 8 Palavras, com palavras de média complexidade<br/>Díficil - 10 palavras, com palavras de alta complexidade</h4></span>
    }
    return (
      <div className="main-side">
        <Nav />
        <div className='container center'>
          <Instrucao
            title={'Instruções'}
            content={texto}
            nav1={<Link to="/instrucao3">
              <Button className='borColor1 Color4 button1 buttonR sizeButton'><Icon icon='caret-left' size='3x' /></Button>
            </Link>
            }
            nav2={
              <Link to="/instrucao5">
                <Button className='borColor1 Color4 button1 buttonR sizeButton'><Icon icon='caret-right' size='3x' /></Button>
              </Link>
            }

            button={
              <Link to="/modo"><h6 className="Color4">PULAR INSTRUÇÕES</h6></Link>
            }

          />
        </div>
      </div>
    );
  }

  function Tela_Inst5() {
    return (
      <div className="main-side">
        <Nav />
        <div className='container center'>
          <Instrucao
            title={'Instruções'}
            content={<h2>Preparado? Então vamos começar! </h2>}
            contentButton ={
              <Link to="/modo">
                <Button className='sizeButton borColor3 Color4 button1 buttonIncial'><Icon icon='gamepad' size='2x' /> Jogar</Button>
              </Link>
            }
            nav1={<Link to="/instrucao4">
              <Button className='borColor1 Color4 button1 buttonR sizeButton'><Icon icon='caret-left' size='3x' /></Button>
            </Link>
            }
            nav2={
              <Link >
                <Button className='buttonR borColor1 Color3 button1  sizeButton' disabled><Icon icon='caret-right' size='3x' /></Button>
              </Link>
            }


          />
        </div>
      </div>
    );
  }

  function Tela_Modo() {

return (
    <div className="main-side">
      <Nav />
      <div className='container center'>
        <Instrucao
          title={'Escolha o nível'}
          contentButton ={
            <div className="col">

              <Link className='sizeButton Color4 distributed' to="/jogo" ><Button appearance="default" id="facil" onClick={() => LevelManager.facil()} className='borColor3 Color4 button1 buttonIncial buttonGroup'><h4><Icon icon='star-o' size='2x' /> Fácil</h4></Button></Link>
              <Link className='sizeButton Color4 distributed' to="/jogo"><Button appearance="default" id="medio" onClick={() => LevelManager.medio()} className='borColor3 Color4 button1 buttonIncial buttonGroup'><h4> <Icon icon='star-half-o' size='2x' />Médio</h4></Button></Link>
              <Link className='sizeButton Color4 distributed' to="/jogo"><Button appearance="default" id="dificil" onClick={() => LevelManager.dificil()} className='borColor3 Color4 button1 buttonIncial buttonGroup'> <h4><Icon icon='star' size='2x' /> Dificil</h4></Button></Link>
                          
            </div>
               
          }

          nav1={
              <div className="fakemodo"></div>
          }
          
          nav2={
              <div className="fakemodo"></div>
          }

        />
      </div>
      </div>
    );
    // return (
    //   <div className='center container baselinelayout' >
    //     <Modo LevelManager={LevelManager} />
    //   </div>
    // );
  }




  function Jogo() {
    return (
      <div className="main-side">
        <Nav />
        <Board level={LevelManager} />
      </div>
    );
  }

  function Fim() {
    return (
      <div>
        <div>
          <h1>Parabéns</h1>
          <p>Você concluiu o nível XXXXX.
Compartilhe seu score ou jogue novamente</p>
        </div>
        <div>
          <div>Time</div>
          <div>3:20</div>
        </div>
        <div>
          <div>Score</div>
          <div>8800</div>
        </div>
        <Link to="/"><button>Jogar novamente</button></Link>
        <Link to="/"><button>compartihar</button></Link>
      </div>
    );
  }


}
